import { FSharpException } from "../fable_modules/fable-library.3.7.14/Types.js";
import { class_type } from "../fable_modules/fable-library.3.7.14/Reflection.js";
import { numberHash, partialApply, equalArrays, uncurry, equals } from "../fable_modules/fable-library.3.7.14/Util.js";
import { reverse, contains, ofArray, tryFind, mapIndexed, empty, singleton as singleton_1, append, length, item, toArray, map as map_1 } from "../fable_modules/fable-library.3.7.14/List.js";
import { PlayerWeapon, WeaponType, WolfensteinMap, GameObject, PathState, BasicGameObject__get_MapPosition, MapDirection__ToDelta, EnemyType, Enemy, Enemy_AnimationTimeForState_4C3F69DE, BasicGameObject as BasicGameObject_2, Vector2D__UnsquaredDistanceFrom_Z41DD997C, Vector2D_op_Subtraction_3C4D5180, PathState_get_Empty, EnemyStateType, MapDirection, DoorStatus, DoorDirection, DoorState, RawMap, Camera, Vector2D__get_CrossProduct, Vector2D_op_Multiply_Z23A8CFC1, Vector2D, Cell, Wall } from "../Model.fs.js";
import { toList, iterate, fold, filter, map as map_2, concat } from "../fable_modules/fable-library.3.7.14/Seq.js";
import { map as map_3, value as value_6 } from "../fable_modules/fable-library.3.7.14/Option.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.14/Range.js";
import { singleton } from "../fable_modules/fable-library.3.7.14/AsyncBuilder.js";
import { loadAsset } from "../Utils.fs.js";
import { MAPHEAD, GAMEMAPS } from "../Assets.fs.js";
import { carmackDecode, rlewDecode } from "./Compression.fs.js";
import { map as map_4 } from "../fable_modules/fable-library.3.7.14/Array.js";

export class MapLoadException extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function MapLoadException$reflection() {
    return class_type("App.Map.MapLoadException", void 0, MapLoadException, class_type("System.Exception"));
}

function MapLoadException__Equals_229D3F39(this$, obj) {
    if (!equals(this$, null)) {
        if (!equals(obj, null)) {
            if (obj instanceof MapLoadException) {
                return this$.Data0 === obj.Data0;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    else if (!equals(obj, null)) {
        return false;
    }
    else {
        return true;
    }
}

export class PlayerStartingPositionNotFoundException extends FSharpException {
    constructor() {
        super();
    }
}

export function PlayerStartingPositionNotFoundException$reflection() {
    return class_type("App.Map.PlayerStartingPositionNotFoundException", void 0, PlayerStartingPositionNotFoundException, class_type("System.Exception"));
}

function PlayerStartingPositionNotFoundException__Equals_229D3F39(this$, obj) {
    if (!equals(this$, null)) {
        if (!equals(obj, null)) {
            if (obj instanceof PlayerStartingPositionNotFoundException) {
                return 1;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    else if (!equals(obj, null)) {
        return false;
    }
    else {
        return true;
    }
}

export class InvalidDoorException extends FSharpException {
    constructor() {
        super();
    }
}

export function InvalidDoorException$reflection() {
    return class_type("App.Map.InvalidDoorException", void 0, InvalidDoorException, class_type("System.Exception"));
}

function InvalidDoorException__Equals_229D3F39(this$, obj) {
    if (!equals(this$, null)) {
        if (!equals(obj, null)) {
            if (obj instanceof InvalidDoorException) {
                return 1;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    else if (!equals(obj, null)) {
        return false;
    }
    else {
        return true;
    }
}

function startingHitPoints(difficultyLevel, enemyType) {
    switch (difficultyLevel.tag) {
        case 1: {
            switch (enemyType.tag) {
                case 1: {
                    return 50;
                }
                case 2: {
                    return 100;
                }
                case 3: {
                    return 1;
                }
                case 4: {
                    return 55;
                }
                case 5: {
                    return 300;
                }
                case 6: {
                    return 950;
                }
                case 7: {
                    return 950;
                }
                case 8: {
                    return 950;
                }
                case 9: {
                    return 850;
                }
                case 10: {
                    return 950;
                }
                case 11: {
                    return 950;
                }
                case 12: {
                    return 25;
                }
                default: {
                    return 25;
                }
            }
        }
        case 2: {
            switch (enemyType.tag) {
                case 1: {
                    return 50;
                }
                case 2: {
                    return 100;
                }
                case 3: {
                    return 1;
                }
                case 4: {
                    return 55;
                }
                case 5: {
                    return 400;
                }
                case 6: {
                    return 1050;
                }
                case 7: {
                    return 1050;
                }
                case 8: {
                    return 1550;
                }
                case 9: {
                    return 1050;
                }
                case 10: {
                    return 1050;
                }
                case 11: {
                    return 1050;
                }
                case 12: {
                    return 25;
                }
                default: {
                    return 25;
                }
            }
        }
        case 3: {
            switch (enemyType.tag) {
                case 1: {
                    return 50;
                }
                case 2: {
                    return 100;
                }
                case 3: {
                    return 1;
                }
                case 4: {
                    return 65;
                }
                case 5: {
                    return 500;
                }
                case 6: {
                    return 1200;
                }
                case 7: {
                    return 1200;
                }
                case 8: {
                    return 2400;
                }
                case 9: {
                    return 1200;
                }
                case 10: {
                    return 1200;
                }
                case 11: {
                    return 1200;
                }
                case 12: {
                    return 25;
                }
                default: {
                    return 25;
                }
            }
        }
        default: {
            switch (enemyType.tag) {
                case 1: {
                    return 50;
                }
                case 2: {
                    return 100;
                }
                case 3: {
                    return 1;
                }
                case 4: {
                    return 45;
                }
                case 5: {
                    return 200;
                }
                case 6: {
                    return 800;
                }
                case 7: {
                    return 850;
                }
                case 8: {
                    return 850;
                }
                case 9: {
                    return 850;
                }
                case 10: {
                    return 850;
                }
                case 11: {
                    return 850;
                }
                case 12: {
                    return 25;
                }
                default: {
                    return 25;
                }
            }
        }
    }
}

export function mapFromTextures(source) {
    return map_1((row) => map_1((textureIndex) => {
        if (textureIndex > 0) {
            return new Cell(0, new Wall(textureIndex, textureIndex));
        }
        else {
            return new Cell(3);
        }
    }, row), source);
}

export function getPlaneValue(plane, x, y) {
    return plane.getUint16(2 * (x + (64 * y)), true);
}

function traverseMap(handler, mapPlane) {
    const mapSize = (~(~Math.sqrt(~(~(mapPlane.byteLength / 2))))) | 0;
    return concat(map_2((rowIndex) => map_2(value_6, filter((option) => (option != null), map_2((colIndex) => handler(colIndex, rowIndex, getPlaneValue(mapPlane, colIndex, rowIndex)), rangeDouble(0, 1, mapSize - 1)))), rangeDouble(0, 1, mapSize - 1)));
}

function getStartingPosition(mapSize, plane1) {
    const cameraOption = fold((outerCameraOption, row) => fold((innerCameraOption, column) => {
        if (innerCameraOption == null) {
            const mapValue = getPlaneValue(plane1, column, row);
            if ((19 <= mapValue) && (mapValue <= 22)) {
                const direction = (mapValue === 19) ? (new Vector2D(0, -1)) : ((mapValue === 20) ? (new Vector2D(-1, 0)) : ((mapValue === 21) ? (new Vector2D(0, 1)) : ((mapValue === 22) ? (new Vector2D(1, 0)) : (new Vector2D(1, 0)))));
                const fieldOfView = 1;
                return new Camera(new Vector2D((mapSize - column) - 0.5, row + 0.5), direction, Vector2D_op_Multiply_Z23A8CFC1(Vector2D__get_CrossProduct(direction), fieldOfView), fieldOfView);
            }
            else {
                return void 0;
            }
        }
        else {
            return innerCameraOption;
        }
    }, outerCameraOption, rangeDouble(0, 1, mapSize)), void 0, rangeDouble(0, 1, mapSize));
    if (cameraOption != null) {
        return cameraOption;
    }
    else {
        throw (new PlayerStartingPositionNotFoundException());
    }
}

export function loadRawMap(levelIndex) {
    return singleton.Delay(() => {
        const createDataView = (size) => (new DataView(new ArrayBuffer(size)));
        return singleton.Bind(loadAsset(GAMEMAPS), (_arg1) => singleton.Bind(loadAsset(MAPHEAD), (_arg2) => {
            let matchValue, copyOfStruct, copyOfStruct_1, mapHeadView, offset, mapHeader, plane0View, plane1View, plane2View;
            return singleton.Return((matchValue = [_arg1, _arg2], (copyOfStruct = matchValue[0], (copyOfStruct.tag === 0) ? ((copyOfStruct_1 = matchValue[1], (copyOfStruct_1.tag === 0) ? ((mapHeadView = (new DataView(copyOfStruct_1.fields[0])), (offset = mapHeadView.getUint32(2 + (4 * levelIndex), true), (mapHeader = (new DataView(copyOfStruct.fields[0], (~(~offset)), 42)), (plane0View = (new DataView(copyOfStruct.fields[0], (~(~mapHeader.getUint32(0, true))), mapHeader.getUint16(12, true))), (plane1View = (new DataView(copyOfStruct.fields[0], (~(~mapHeader.getUint32(4, true))), mapHeader.getUint16(14, true))), (plane2View = (new DataView(copyOfStruct.fields[0], (~(~mapHeader.getUint32(4, true))), mapHeader.getUint16(14, true))), new RawMap(64, rlewDecode(createDataView, mapHeadView, carmackDecode(createDataView, plane0View)), rlewDecode(createDataView, mapHeadView, carmackDecode(createDataView, plane1View)), rlewDecode(createDataView, mapHeadView, carmackDecode(createDataView, plane2View)))))))))) : (() => {
                throw (new MapLoadException("Unexpected error"));
            })())) : (() => {
                throw (new MapLoadException("Unexpected error"));
            })())));
        }));
    });
}

export function calculateAreasFromMap(map, doors) {
    let areas = toArray(map_1((row) => toArray(map_1((_arg1) => -1, row)), map));
    let currentArea = 0;
    const walk = (rowIndex, colIndex) => {
        if ((((rowIndex >= 0) && (rowIndex < 64)) && (colIndex >= 0)) && (colIndex < 64)) {
            if (areas[rowIndex][colIndex] === -1) {
                const matchValue = item(colIndex, item(rowIndex, map));
                switch (matchValue.tag) {
                    case 3:
                    case 2: {
                        areas[rowIndex][colIndex] = (currentArea | 0);
                        walk(rowIndex - 1, colIndex);
                        walk(rowIndex + 1, colIndex);
                        walk(rowIndex, colIndex - 1);
                        walk(rowIndex, colIndex + 1);
                        return true;
                    }
                    default: {
                        return false;
                    }
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    iterate((rowIndex_1) => {
        iterate((colIndex_1) => {
            if (walk(rowIndex_1, colIndex_1)) {
                currentArea = ((currentArea + 1) | 0);
            }
        }, rangeDouble(0, 1, length(item(rowIndex_1, map)) - 1));
    }, rangeDouble(0, 1, length(map) - 1));
    const doorsPatchedWithAreas = map_1((door) => {
        const patternInput = door.MapPosition;
        const doorY = patternInput[1] | 0;
        const doorX = patternInput[0] | 0;
        if (door.DoorDirection.tag === 1) {
            areas[doorY][doorX] = (areas[doorY - 1][doorX] | 0);
            return new DoorState(door.TextureIndex, door.DoorDirection, door.Status, door.Offset, door.TimeRemainingInAnimationState, door.MapPosition, areas[doorY - 1][doorX], areas[doorY + 1][doorX]);
        }
        else {
            areas[doorY][doorX] = (areas[doorY][doorX - 1] | 0);
            return new DoorState(door.TextureIndex, door.DoorDirection, door.Status, door.Offset, door.TimeRemainingInAnimationState, door.MapPosition, areas[doorY][doorX - 1], areas[doorY][doorX + 1]);
        }
    }, doors);
    return [areas, doorsPatchedWithAreas, currentArea];
}

export function loadLevelFromRawMap(difficulty, raw) {
    const patternInput_2 = fold((tupledArg, rowIndex) => {
        const patternInput_1 = fold(uncurry(2, (tupledArg_1) => {
            const row = tupledArg_1[0];
            const innerDoors = tupledArg_1[1];
            return (colIndex) => {
                const rawMapCell = raw.Plane0.getUint16(2 * (colIndex + (64 * rowIndex)), true);
                if (rawMapCell <= 63) {
                    const textureIndex = ((2 * (~(~rawMapCell))) - 1) | 0;
                    return [append(row, singleton_1(new Cell(0, new Wall(textureIndex, textureIndex - 1)))), innerDoors];
                }
                else if ((rawMapCell >= 90) && (rawMapCell <= 101)) {
                    let patternInput;
                    if (rawMapCell === 90) {
                        patternInput = [99, new DoorDirection(0)];
                    }
                    else if (rawMapCell === 92) {
                        patternInput = [105, new DoorDirection(0)];
                    }
                    else if (rawMapCell === 94) {
                        patternInput = [105, new DoorDirection(0)];
                    }
                    else if (rawMapCell === 100) {
                        patternInput = [103, new DoorDirection(0)];
                    }
                    else if (rawMapCell === 91) {
                        patternInput = [98, new DoorDirection(1)];
                    }
                    else if (rawMapCell === 93) {
                        patternInput = [104, new DoorDirection(1)];
                    }
                    else if (rawMapCell === 95) {
                        patternInput = [104, new DoorDirection(1)];
                    }
                    else if (rawMapCell === 101) {
                        patternInput = [102, new DoorDirection(1)];
                    }
                    else {
                        throw (new InvalidDoorException());
                    }
                    const doorState = new DoorState(patternInput[0], patternInput[1], new DoorStatus(3), 0, 0, [colIndex, rowIndex], -1, -1);
                    return [append(row, singleton_1(new Cell(1, length(innerDoors)))), append(innerDoors, singleton_1(doorState))];
                }
                else {
                    const objectValue = getPlaneValue(raw.Plane1, colIndex, rowIndex);
                    return [append(row, singleton_1((objectValue === 90) ? (new Cell(2, new MapDirection(2))) : ((objectValue === 91) ? (new Cell(2, new MapDirection(1))) : ((objectValue === 92) ? (new Cell(2, new MapDirection(0))) : ((objectValue === 93) ? (new Cell(2, new MapDirection(7))) : ((objectValue === 94) ? (new Cell(2, new MapDirection(6))) : ((objectValue === 95) ? (new Cell(2, new MapDirection(5))) : ((objectValue === 96) ? (new Cell(2, new MapDirection(4))) : ((objectValue === 97) ? (new Cell(2, new MapDirection(3))) : (new Cell(3))))))))))), innerDoors];
                }
            };
        }), [empty(), tupledArg[1]], rangeDouble(0, 1, raw.MapSize - 1));
        return [append(tupledArg[0], singleton_1(patternInput_1[0])), patternInput_1[1]];
    }, [empty(), empty()], rangeDouble(0, 1, raw.MapSize - 1));
    const doors = patternInput_2[1];
    const patchedPlane0 = mapIndexed((rowIndex_1, row_1) => mapIndexed((colIndex_1, cell_1) => {
        if (cell_1.tag === 0) {
            const wall = cell_1.fields[0];
            return new Cell(0, new Wall(((tryFind((doorState_1) => equalArrays(doorState_1.MapPosition, [colIndex_1 + 1, rowIndex_1]), doors) != null) ? true : (tryFind((doorState_2) => equalArrays(doorState_2.MapPosition, [colIndex_1 - 1, rowIndex_1]), doors) != null)) ? 100 : wall.NorthSouthTextureIndex, ((tryFind((doorState_3) => equalArrays(doorState_3.MapPosition, [colIndex_1, rowIndex_1 + 1]), doors) != null) ? true : (tryFind((doorState_4) => equalArrays(doorState_4.MapPosition, [colIndex_1, rowIndex_1 - 1]), doors) != null)) ? 101 : wall.EastWestTextureIndex));
        }
        else {
            return cell_1;
        }
    }, row_1), patternInput_2[0]);
    const playerStartingPosition = getStartingPosition(raw.MapSize, raw.Plane1);
    const standingOrMoving = (baseValue, value) => {
        if ((value - baseValue) < 4) {
            return new EnemyStateType(0);
        }
        else {
            return new EnemyStateType(3, PathState_get_Empty());
        }
    };
    let gameObjects;
    const createEnemy = (spriteIndex_1, spriteBlocks, framesPerBlock, deathSprites, hurtSpriteIndex, attackingSprites, score, patrolSpeed, chaseSpeed, enemyType, x, y, directionIntOption, startingState) => {
        let directionOption, direction_1;
        const position = new Vector2D((raw.MapSize - x) - 0.5, y + 0.5);
        const State = (raw.Plane0.getUint16(2 * (x + (64 * y)), true) === 106) ? (new EnemyStateType(1)) : startingState;
        return new Enemy(enemyType, new BasicGameObject_2(position, Vector2D_op_Subtraction_3C4D5180(position, playerStartingPosition.Position), Vector2D__UnsquaredDistanceFrom_Z41DD997C(position, playerStartingPosition.Position), spriteIndex_1, true, false, 0, 0, 0, score, true), (directionOption = directionIntOption, (directionOption == null) ? (new MapDirection(8)) : ((direction_1 = directionOption, (direction_1 === 0) ? (new MapDirection(2)) : ((direction_1 === 1) ? (new MapDirection(0)) : ((direction_1 === 2) ? (new MapDirection(6)) : ((direction_1 === 3) ? (new MapDirection(4)) : (() => {
            throw (new MapLoadException(`Direction of ${direction_1} int not between 0 and 3`));
        })())))))), deathSprites, attackingSprites, spriteBlocks, framesPerBlock, 0, Enemy_AnimationTimeForState_4C3F69DE(startingState), State, true, false, false, startingHitPoints(difficulty, enemyType), hurtSpriteIndex, patrolSpeed, chaseSpeed);
    };
    const guardEnemy = partialApply(4, createEnemy, [50, 4, 8, ofArray([90, 91, 92, 93, 95]), 94, ofArray([96, 97, 98]), 100, 0.5, 1, new EnemyType(0)]);
    const dogEnemy = partialApply(4, createEnemy, [99, 3, 8, ofArray([131, 132, 133, 134]), 131, ofArray([135, 136, 137]), 200, 1, 1.5, new EnemyType(3)]);
    const officerEnemy = partialApply(4, createEnemy, [138, 4, 8, ofArray([179, 180, 181, 183]), 182, ofArray([184, 185, 186]), 500, 0.5, 1.25, new EnemyType(2)]);
    const zombieEnemy = partialApply(4, createEnemy, [187, 4, 8, ofArray([228, 229, 230, 232, 233]), 231, ofArray([234, 235, 236, 237]), 700, 0.5, 1, new EnemyType(4)]);
    const leonEnemy = partialApply(4, createEnemy, [238, 4, 8, ofArray([279, 280, 281, 283, 284]), 282, ofArray([285, 286, 287]), 400, 0.5, 1.25, new EnemyType(1)]);
    const hansEnemy = partialApply(4, createEnemy, [296, 1, 4, ofArray([304, 305, 306, 303]), 304, ofArray([300, 301, 302]), 2000, 0.5, 1, new EnemyType(10)]);
    const schabbsEnemy = partialApply(4, createEnemy, [307, 1, 4, ofArray([313, 314, 315, 316]), 313, ofArray([311, 312]), 2000, 0.5, 1, new EnemyType(8)]);
    const fakeAdolfEnemy = partialApply(4, createEnemy, [321, 1, 4, ofArray([328, 329, 330, 331, 332, 333]), 328, singleton_1(325), 2000, 0.5, 1, new EnemyType(5)]);
    const adolfEnemy = partialApply(4, createEnemy, [345, 1, 4, ofArray([353, 354, 355, 356, 357, 358, 359, 352]), 353, ofArray([349, 350, 351]), 5000, 0.5, 1, new EnemyType(6)]);
    const ottoEnemy = partialApply(4, createEnemy, [360, 1, 4, ofArray([366, 367, 368, 369]), 366, ofArray([364, 365]), 5000, 0.5, 1, new EnemyType(11)]);
    const gretelEnemy = partialApply(4, createEnemy, [385, 1, 4, ofArray([393, 394, 395, 392]), 393, ofArray([389, 390, 391]), 5000, 0.5, 1, new EnemyType(9)]);
    const fettgesichtEnemy = partialApply(4, createEnemy, [396, 1, 4, ofArray([404, 405, 406, 407]), 404, ofArray([400, 401, 402, 403]), 5000, 0.5, 1, new EnemyType(7)]);
    const withHitPoints = (pts, go) => (new BasicGameObject_2(go.Position, go.PlayerRelativePosition, go.UnsquaredDistanceFromPlayer, go.SpriteIndex, go.CollidesWithBullets, true, pts, go.AmmoRestored, go.LivesRestored, go.Score, go.Blocking));
    const withScore = (pts_1, go_1) => (new BasicGameObject_2(go_1.Position, go_1.PlayerRelativePosition, go_1.UnsquaredDistanceFromPlayer, go_1.SpriteIndex, go_1.CollidesWithBullets, true, go_1.HitpointsRestored, go_1.AmmoRestored, go_1.LivesRestored, pts_1, go_1.Blocking));
    gameObjects = map_1((gameObject) => {
        let patternInput_3, patternInput_4, patternInput_5;
        if (gameObject.tag === 1) {
            const e_1 = gameObject.fields[0];
            return new GameObject(1, (e_1.State.tag === 3) ? ((patternInput_3 = MapDirection__ToDelta(e_1.Direction), (patternInput_4 = BasicGameObject__get_MapPosition(e_1.BasicGameObject), (patternInput_5 = [patternInput_4[0] + patternInput_3[0], patternInput_4[1] + patternInput_3[1]], new Enemy(e_1.EnemyType, e_1.BasicGameObject, e_1.Direction, e_1.DeathSpriteIndexes, e_1.AttackSpriteIndexes, e_1.SpriteBlocks, e_1.FramesPerBlock, e_1.CurrentAnimationFrame, e_1.TimeUntilNextAnimationFrame, new EnemyStateType(3, new PathState(patternInput_5[0], patternInput_5[1], false)), e_1.IsFirstAttack, e_1.FireAtPlayerRequired, e_1.MoveToChaseRequired, e_1.HitPoints, e_1.HurtSpriteIndex, e_1.PatrolSpeed, e_1.ChaseSpeed))))) : e_1);
        }
        else {
            return gameObject;
        }
    }, toList(traverseMap((colIndex_2, rowIndex_2, value_2) => {
        let position_1, basicGameObject, SpriteIndex, go_2, go_3, bo, deadGuard, inputRecord;
        if ((value_2 >= 23) && (value_2 <= 70)) {
            return new GameObject(0, (position_1 = (new Vector2D((raw.MapSize - colIndex_2) - 0.5, rowIndex_2 + 0.5)), (basicGameObject = ((SpriteIndex = (((~(~value_2)) - 21) | 0), new BasicGameObject_2(position_1, Vector2D_op_Subtraction_3C4D5180(position_1, playerStartingPosition.Position), Vector2D__UnsquaredDistanceFrom_Z41DD997C(position_1, playerStartingPosition.Position), SpriteIndex, false, false, 0, 0, 0, 0, false))), (value_2 === 29) ? withHitPoints(4, basicGameObject) : ((value_2 === 47) ? withHitPoints(10, basicGameObject) : ((value_2 === 48) ? withHitPoints(25, basicGameObject) : ((value_2 === 49) ? ((go_2 = basicGameObject, new BasicGameObject_2(go_2.Position, go_2.PlayerRelativePosition, go_2.UnsquaredDistanceFromPlayer, go_2.SpriteIndex, go_2.CollidesWithBullets, true, go_2.HitpointsRestored, 8, go_2.LivesRestored, go_2.Score, go_2.Blocking))) : ((value_2 === 52) ? withScore(100, basicGameObject) : ((value_2 === 53) ? withScore(500, basicGameObject) : ((value_2 === 54) ? withScore(1000, basicGameObject) : ((value_2 === 55) ? withScore(5000, basicGameObject) : ((value_2 === 56) ? ((go_3 = basicGameObject, new BasicGameObject_2(go_3.Position, go_3.PlayerRelativePosition, go_3.UnsquaredDistanceFromPlayer, go_3.SpriteIndex, go_3.CollidesWithBullets, true, go_3.HitpointsRestored, go_3.AmmoRestored, 1, go_3.Score, go_3.Blocking))) : ((bo = basicGameObject, contains(value_2, ofArray([25, 26, 30, 34, 35, 36, 38, 39, 40, 41, 59, 60, 68, 69, 70, 71]), {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: numberHash,
            }) ? (new BasicGameObject_2(bo.Position, bo.PlayerRelativePosition, bo.UnsquaredDistanceFromPlayer, bo.SpriteIndex, bo.CollidesWithBullets, bo.Pickupable, bo.HitpointsRestored, bo.AmmoRestored, bo.LivesRestored, bo.Score, true)) : bo)))))))))))));
        }
        else if (value_2 >= 108) {
            return map_3((e) => (new GameObject(1, e)), ((108 <= value_2) && (value_2 < 116)) ? guardEnemy(colIndex_2)(rowIndex_2)((value_2 - 108) % 4)(standingOrMoving(108, value_2)) : (((144 <= value_2) && (value_2 < 152)) ? guardEnemy(colIndex_2)(rowIndex_2)((value_2 - 144) % 4)(standingOrMoving(144, value_2)) : (((180 <= value_2) && (value_2 < 188)) ? guardEnemy(colIndex_2)(rowIndex_2)((value_2 - 180) % 4)(standingOrMoving(180, value_2)) : (((116 <= value_2) && (value_2 < 124)) ? leonEnemy(colIndex_2)(rowIndex_2)((value_2 - 116) % 4)(standingOrMoving(116, value_2)) : (((152 <= value_2) && (value_2 < 160)) ? leonEnemy(colIndex_2)(rowIndex_2)((value_2 - 152) % 4)(standingOrMoving(152, value_2)) : (((188 <= value_2) && (value_2 < 196)) ? leonEnemy(colIndex_2)(rowIndex_2)((value_2 - 188) % 4)(standingOrMoving(188, value_2)) : (((126 <= value_2) && (value_2 < 134)) ? officerEnemy(colIndex_2)(rowIndex_2)((value_2 - 126) % 4)(standingOrMoving(126, value_2)) : (((162 <= value_2) && (value_2 < 170)) ? officerEnemy(colIndex_2)(rowIndex_2)((value_2 - 162) % 4)(standingOrMoving(162, value_2)) : (((198 <= value_2) && (value_2 < 206)) ? officerEnemy(colIndex_2)(rowIndex_2)((value_2 - 198) % 4)(standingOrMoving(198, value_2)) : ((124 === value_2) ? ((deadGuard = guardEnemy(colIndex_2)(rowIndex_2)((value_2 - 108) % 4)(new EnemyStateType(8)), new Enemy(deadGuard.EnemyType, (inputRecord = deadGuard.BasicGameObject, new BasicGameObject_2(inputRecord.Position, inputRecord.PlayerRelativePosition, inputRecord.UnsquaredDistanceFromPlayer, inputRecord.SpriteIndex, inputRecord.CollidesWithBullets, inputRecord.Pickupable, inputRecord.HitpointsRestored, inputRecord.AmmoRestored, inputRecord.LivesRestored, inputRecord.Score, false)), deadGuard.Direction, deadGuard.DeathSpriteIndexes, deadGuard.AttackSpriteIndexes, deadGuard.SpriteBlocks, deadGuard.FramesPerBlock, length(deadGuard.DeathSpriteIndexes) - 1, deadGuard.TimeUntilNextAnimationFrame, deadGuard.State, deadGuard.IsFirstAttack, deadGuard.FireAtPlayerRequired, deadGuard.MoveToChaseRequired, deadGuard.HitPoints, deadGuard.HurtSpriteIndex, deadGuard.PatrolSpeed, deadGuard.ChaseSpeed))) : (((138 <= value_2) && (value_2 < 142)) ? dogEnemy(colIndex_2)(rowIndex_2)((value_2 - 138) % 4)(new EnemyStateType(3, PathState_get_Empty())) : (((174 <= value_2) && (value_2 < 178)) ? dogEnemy(colIndex_2)(rowIndex_2)((value_2 - 174) % 4)(new EnemyStateType(3, PathState_get_Empty())) : (((210 <= value_2) && (value_2 < 214)) ? dogEnemy(colIndex_2)(rowIndex_2)((value_2 - 210) % 4)(new EnemyStateType(3, PathState_get_Empty())) : (((216 <= value_2) && (value_2 < 224)) ? zombieEnemy(colIndex_2)(rowIndex_2)((value_2 - 216) % 4)(standingOrMoving(216, value_2)) : (((234 <= value_2) && (value_2 < 242)) ? zombieEnemy(colIndex_2)(rowIndex_2)((value_2 - 234) % 4)(standingOrMoving(234, value_2)) : ((value_2 === 160) ? fakeAdolfEnemy(colIndex_2)(rowIndex_2)(void 0)(new EnemyStateType(1)) : ((value_2 === 178) ? adolfEnemy(colIndex_2)(rowIndex_2)(void 0)(new EnemyStateType(1)) : ((value_2 === 179) ? fettgesichtEnemy(colIndex_2)(rowIndex_2)(void 0)(new EnemyStateType(1)) : ((value_2 === 196) ? schabbsEnemy(colIndex_2)(rowIndex_2)(void 0)(new EnemyStateType(1)) : ((value_2 === 197) ? gretelEnemy(colIndex_2)(rowIndex_2)(void 0)(new EnemyStateType(1)) : ((value_2 === 214) ? hansEnemy(colIndex_2)(rowIndex_2)(void 0)(new EnemyStateType(1)) : ((value_2 === 215) ? ottoEnemy(colIndex_2)(rowIndex_2)(void 0)(new EnemyStateType(1)) : (void 0)))))))))))))))))))))));
        }
        else {
            return void 0;
        }
    }, raw.Plane1)));
    const map = map_1(reverse, patchedPlane0);
    const patternInput_6 = calculateAreasFromMap(map, map_1((door) => {
        let tupledArg_2;
        return new DoorState(door.TextureIndex, door.DoorDirection, door.Status, door.Offset, door.TimeRemainingInAnimationState, (tupledArg_2 = door.MapPosition, [(raw.MapSize - 1) - tupledArg_2[0], tupledArg_2[1]]), door.AreaOne, door.AreaTwo);
    }, doors));
    return new WolfensteinMap(raw.MapSize, raw.MapSize, map, ofArray(map_4(ofArray, patternInput_6[0])), patternInput_6[2] + 1, gameObjects, playerStartingPosition, patternInput_6[1]);
}

export function createAmmo(playerPosition, mapX, mapY) {
    let SpriteIndex;
    const position = new Vector2D(mapX + 0.5, mapY + 0.5);
    return new GameObject(0, (SpriteIndex = ((49 - 21) | 0), new BasicGameObject_2(position, Vector2D_op_Subtraction_3C4D5180(position, playerPosition), Vector2D__UnsquaredDistanceFrom_Z41DD997C(position, playerPosition), SpriteIndex, false, true, 0, 4, 0, 0, false)));
}

export function getWeapon(sprites, weaponType, scaleSprite) {
    const toSpriteSet = (sequence) => toList(map_2((i) => scaleSprite(sprites[i]), sequence));
    switch (weaponType.tag) {
        case 1: {
            return new PlayerWeapon(append(toSpriteSet(rangeDouble(421, 1, 425)), toSpriteSet(rangeDouble(424, 1, 422))), 0, 25, false, true, 1, new WeaponType(1));
        }
        case 2: {
            return new PlayerWeapon(toSpriteSet(rangeDouble(426, 1, 430)), 0, 25, true, true, 2, new WeaponType(2));
        }
        case 3: {
            return new PlayerWeapon(toSpriteSet(rangeDouble(431, 1, 435)), 0, 25, true, true, 3, new WeaponType(3));
        }
        default: {
            return new PlayerWeapon(toSpriteSet(rangeDouble(416, 1, 420)), 0, 25, false, false, 0, new WeaponType(0));
        }
    }
}

